/** What "Set crew" writes back: the two Service Line crew binds, projected to tiny refs. */
import { Entity } from '@jms/model';

export interface OutlineCrewSelection {
  defaultContractor: Entity | null;
  defaultResources: Entity[];
}

/**
 * Picker options arrive fat — avatars, colors, descriptions, the whole picker projection. The API
 * stores a Service Line's crew as an embedded ref, and `outlineCrewEntities` only ever reads `_id`
 * and `name`, so anything else on the option is dead weight that would be written to the document
 * and then read back into the row renderer. Trim to the two fields both sides actually use.
 */
export function outlineCrewRef(value: Entity | null | undefined): Entity | null {

  const id = value?._id;
  if (!id) return null;
  return { _id: id, name: value.name } as Entity;
}

/** Tiny refs for a multi picker, dropping blanks and repeats so a re-pick cannot double an id. */
export function outlineCrewRefs(values: readonly Entity[] | null | undefined): Entity[] {

  const seen = new Set<string>();
  const refs: Entity[] = [];
  for (const value of values ?? []) {
    const ref = outlineCrewRef(value);
    if (!ref || seen.has(ref._id)) continue;
    seen.add(ref._id);
    refs.push(ref);
  }
  return refs;
}

/** The dialog's whole answer, ready to PATCH. A cleared contractor is `null`, never absent. */
export function outlineCrewSelection(contractor: Entity | null | undefined, resources: readonly Entity[] | null | undefined): OutlineCrewSelection {

  return { defaultContractor: outlineCrewRef(contractor), defaultResources: outlineCrewRefs(resources) };
}
